import { WELCOME_SCREEN_CLOSE_DURATION } from "assets/constants/welcomeScreenCloseDuration";

export const PROGRESS_TRANSITION = "0.4s ease-in-out";
export const FRAME_TRANSITION = `${WELCOME_SCREEN_CLOSE_DURATION}ms ease-in-out`;
export const BOTTOM_NAV_HEIGHT = 260;
